import { create } from "zustand"
import { getOrgReportRawApi } from "@/apis/org-api"

export const tableStore = create((set, get) => ({
  /* ------------------ DATA ------------------ */

  headers: [],
  rows: [],

  pageMeta: {
    totalCount: 0,
    page: 1,
    totalPage: 1,
    size: 20
  },

  setPageMeta: (meta) =>
    set((state) => ({
      pageMeta: {
        ...state.pageMeta,
        ...meta
      }
    })),

  sort: {
    key: "leak_rate",
    order: "desc"
  },

  filters: {
    ranges: {},
    enums: {},
    search: ""
  },

  initialRanges: {},
  initialEnums: {},

  /* ------------------ FETCH ------------------ */

  buildQuery: () => {
    const { pageMeta, sort, filters, initialRanges } = get()

    const options = {
      page: pageMeta.page,
      size: pageMeta.size,
      sort_key: sort.key,
      sort_order: sort.order
    }

    Object.entries(filters.ranges).forEach(([key, value]) => {
      const { min: min1, max: max1 } = initialRanges[key]
      const { min: min2, max: max2 } = value
      if (min1 === min2 && max1 === max2) return
      options[key] = value
    })

    Object.entries(filters.enums).forEach(([key, value]) => {
      if (value.length === 0) return
      options[key] = value
    })

    if (filters.search) {
      options.search = filters.search
    }

    return options
  },

  fetchData: async (org) => {
    const options = get().buildQuery()

    const { rows, total, page, size } = await getOrgReportRawApi(org, options)

    set({
      rows,
      pageMeta: {
        totalCount: total,
        page,
        size,
        totalPage: Math.ceil(total / size)
      }
    })
  },

  /* ------------------ SORT ------------------ */

  setSort: async (org, key) => {
    const { sort } = get()

    let order = "desc"

    if (sort.key === key) {
      order = sort.order === "desc" ? "asc" : "desc"
    }

    set({
      sort: { key, order },
      pageMeta: { ...get().pageMeta, page: 1 }
    })

    await get().fetchData(org)
  },

  /* ------------------ PAGINATION ------------------ */

  setPage: async (org, page) => {
    set({
      pageMeta: { ...get().pageMeta, page }
    })

    await get().fetchData(org)
  },

  /* ------------------ FILTERS ------------------ */

  setInitialRanges: (key, values) => {
    set((state) => ({
      initialRanges: {
        ...state.initialRanges,
        [key]: values
      },
      filters: {
        ...state.filters,
        ranges: {
          ...state.filters.ranges,
          [key]: values
        }
      }
    }))
  },

  setInitialEnums: (key, values) => {
    set((state) => ({
      initailEnums: {
        ...state.initailEnums,
        [key]: values
      },
      filters: {
        ...state.filters,
        enums: {
          ...state.filters.enums,
          [key]: []
        }
      }
    }))
  },

  setRangeFilter: (key, values) => {
    set((state) => ({
      filters: {
        ...state.filters,
        ranges: {
          ...state.filters.ranges,
          [key]: values
        }
      }
    }))
  },

  toggleFilter: (group, value) => {
    set((state) => {
      const list = state.filters.enums[group]
      const exists = list.includes(value)

      return {
        filters: {
          ...state.filters,
          enums: {
            ...state.filters.enums,
            [group]: exists ? list.filter((v) => v !== value) : [...list, value]
          }
        }
      }
    })
  },

  setSearchTerm: async (org, term) => {
    ;(set((state) => ({
      filters: {
        ...state.filters,
        search: term
      }
    })),
      await get().fetchData(org))
  },

  applyFilters: async (org) => {
    set({
      pageMeta: { ...get().pageMeta, page: 1 }
    })

    await get().fetchData(org)
  },

  resetFilter: () => {
    const { initialRanges, initailEnums, pageMeta } = get()
    const resetEnums = {}
    for (const key in initailEnums) {
      resetEnums[key] = []
    }

    set({
      filters: {
        ranges: { ...initialRanges },
        enums: { ...resetEnums }
      },
      pageMeta: { ...pageMeta, page: 1 }
    })
  },

  /* ------------------ HEADERS ------------------ */

  setHeaders: (headers) => set({ headers })
}))
